"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartMonthSelector = void 0;
/** @jsx jsx */
var core_1 = require("@emotion/core");
var lodash_1 = require("lodash");
var HFlow_1 = require("../../HFlow");
var Text_1 = require("../../Text");
var MonthPaginator_1 = require("../../MonthPaginator");
function ChartMonthSelector(props) {
    var label = props.label, onChange = props.onChange;
    var onClick = function (newValue) {
        var newDate = new Date(newValue.year, newValue.month, 1);
        var newInit = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
        var newEnd = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
        onChange(function (_a) {
            var init = _a.init, end = _a.end, rest = __rest(_a, ["init", "end"]);
            return lodash_1.merge({}, { init: newInit, end: newEnd }, __assign({}, rest));
        });
    };
    return (core_1.jsx(HFlow_1.HFlow, { hSpacing: 0, alignItems: 'center', justifyContent: 'flex-end', style: core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        margin-left: auto;\n        line-height: 1.5rem;\n      "], ["\n        margin-left: auto;\n        line-height: 1.5rem;\n      "]))) },
        core_1.jsx(Text_1.Text, null,
            label,
            ":"),
        core_1.jsx(MonthPaginator_1.MonthPaginator, { onChange: onClick, formatter: function (date, month) { return month.format(date).replace('.', ''); }, ghost: true, popperPlacement: 'bottom-end' })));
}
exports.ChartMonthSelector = ChartMonthSelector;
ChartMonthSelector.defaultProps = {
    label: 'Competência',
};
var templateObject_1;
//# sourceMappingURL=ChartMonthSelector.js.map